module.exports = __webpack_public_path__ + "assets/img/1f49759de84cf2dc9390991dcf9ecb0a.svg";